import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import React from 'react';
import AndroidStoreBadgeImage from '../../public/images/android_play_store_badge.svg';
import IosStoreBadgeImage from '../../public/images/ios_app_store-badge.svg';
import logEvent from '../helpers/mutations/logEvent';

const HEIGHT_RATIO = 3.375;

type Platform = 'ios' | 'android';

type Props = {
  platform: Platform;
  width: number;
  height?: number;
  target: string;
};

/*
  Note: This component has been adapted from the react-store-badge library: https://github.com/yjb94/react-store-badges/blob/master/src/index.js
  Locale-related functionality has been removed.
 */
//

export const IOS_STORE_URL =
  'https://apps.apple.com/ca/app/tophouse-real-estate/id1593733528';
export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.tophouse';

const AppStoreBadge = ({
  platform,
  width = 135,
  height = width / HEIGHT_RATIO,
  target = '_self',
}: Props) => {
  const Image =
    platform === 'ios' ? IosStoreBadgeImage : AndroidStoreBadgeImage;
  const url = platform === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL;

  return (
    <a
      href={url}
      target={target}
      onClick={() => {
        logEvent({
          action:
            platform === 'ios'
              ? AnalyticsEventAction.clicked_app_store_link_for_ios
              : AnalyticsEventAction.clicked_app_store_link_for_android,
          type: AnalyticsEventType.app_store_link_click,
        });
      }}
    >
      <Image
        alt={
          platform === 'ios'
            ? 'Apple App Store Badge'
            : 'Android Play Store badge'
        }
        width={width}
        height={height}
      />
    </a>
  );
};
export default AppStoreBadge;
